export default {
  defaultObject () {
    return {
      id: undefined,
      name: '',
      description: '',
      wialonToken: '',
      wialonResource: 0
    }
  }
}